/**
 * @module-isolated analytics-cohort
 * @depends analytics-api.js
 */
import { fetchSalesAnalytics, syncKommoLeads, listMetaCsvKommoPipelines } from '../../../services/analytics-api.js';
import { getIdToken } from '../../../services/firebase-auth.js';

export async function loadCohortNow(filters) {
  const token = await getIdToken(false);
  return fetchSalesAnalytics(
    {
      dateFrom: filters.dateFrom,
      dateTo: filters.dateTo,
      mode: 'cohort'
    },
    token
  );
}

export async function syncCohortSource(opts) {
  const token = await getIdToken(false);
  return syncKommoLeads(token, {
    tipo: (opts && opts.tipo) || 'full',
    completeScan: true,
    turnstileToken: (opts && opts.turnstileToken) || ''
  });
}

/**
 * Consulta el orden oficial de etapas de Kommo usando el endpoint read-only
 * existente de embudos; no depende de cuándo se sincronizó la hoja espejo.
 */
export async function loadKommoStageOrder() {
  const token = await getIdToken(false);
  const result = await listMetaCsvKommoPipelines(token);
  const data = result && Array.isArray(result.pipelines)
    ? result
    : result && result.data && Array.isArray(result.data.pipelines)
      ? result.data
      : null;
  if (!data || data.success === false) {
    throw new Error(
      (result && (result.error || result.message)) ||
      'No se pudo consultar el orden de etapas en Kommo.'
    );
  }
  return data.pipelines;
}
